import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
import { routes } from './app.routes';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ConfigurationService } from './core/services/api/configuration.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MsalGuardConfiguration } from '@azure/msal-angular';
import { PublicClientApplication, IPublicClientApplication, InteractionType } from '@azure/msal-browser';
import { APP_AUTH_CONFIG, AUTH_WIDGETS } from './features/login/auth.tokens';
import { environment } from 'src/environment';
import { DatePipe } from '@angular/common';
import { NetworkAndServerErrorInterceptor } from './interceptor.ts/network-and-server-error.interceptor';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { DateTimeInterceptor } from './interceptor.ts/date-time.interceptor ';
import { AdLoginComponent } from './features/login/ad-login/ad-login.component';
import { IdOtpLoginComponent } from './features/login/id-otp-login/id-otp-login.component';

export function configLoader(
  configService: ConfigurationService
): () => Promise<any> {
  return () => configService.load('/assets/config.json');
}
const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;
export function MSALInstanceFactory(): IPublicClientApplication {
  const msalConfig = {
    auth: {
      clientId: environment.azureApps.clientId,
      authority: `https://login.microsoftonline.com/${environment.azureApps.tenatId}`,
      redirectUri: environment.redirectUri, // Redirect URI for your app
      postLogoutRedirectUri: "/",
      // clientCapabilities:["CP1"],
    },
    cache: {
      cacheLocation: 'sessionStorage', // Use 'localStorage' or 'sessionStorage'
      storeAuthStateInCookie: false,//isIE
    },
  };
  const pca = new PublicClientApplication(msalConfig);

  // Initialize MSAL instance
  pca.initialize();

  return pca;
}
export function MSALInterceptorConfigFactory(): any {
  return {
    interactionType: InteractionType.Redirect, // or InteractionType.Popup
    protectedResourceMap: new Map([
      [environment.apiUrl, [environment.azureApps.apiScope]]
    ]),
  } as MsalInterceptorConfiguration
};
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return { interactionType: InteractionType.Redirect };
}
var azureInterceptor = [

  {
    provide: HTTP_INTERCEPTORS,
    useClass: MsalInterceptor,
    multi: true,
  },
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory,
  },
  {
    provide: MSAL_GUARD_CONFIG,
    useFactory: MSALGuardConfigFactory,
  },
]

export const appConfig: ApplicationConfig = {

  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
    {
      provide: APP_INITIALIZER,
      useFactory: configLoader,
      multi: true,
      deps: [ConfigurationService],
    },
    importProvidersFrom([
      MsalModule.forRoot(
        MSALInstanceFactory(),
        MSALGuardConfigFactory(),
        MSALInterceptorConfigFactory()
      )]),
    MsalBroadcastService,
    MsalService,
    MsalGuard,
    environment.auth == "azure" ? azureInterceptor : [],
    provideTranslateService(),
    provideTranslateHttpLoader(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DateTimeInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkAndServerErrorInterceptor,
      multi: true,
    },
    {
      provide: AUTH_WIDGETS,
      useValue: {
        'id&otp': IdOtpLoginComponent,
        // email: EmailLoginComponent,
        'ad': AdLoginComponent,
        // password: EmailLoginComponent // לדוגמה, אפשר אחרת
      } as const
    },
    {
      provide: APP_AUTH_CONFIG,
      useValue: {
        auth: environment.auth,
        loginMethod: environment.loginMethod || 'id&otp',
        adminLoginMethod: environment.adminLoginMethod || 'ad',
        endpoints: {
          'id&otp': 'loginWithId&OTP',
          'ad': 'loginAD'
        }
      }
    },
    importProvidersFrom([MatDialogModule]),
    DatePipe,
    // {
    //   provide:LOCALE_ID , 
    //   useValue:'he'
    // },
    provideAnimations(),
    provideAngularSvgIcon()
  ],
};
